import { useSelector } from 'react-redux';
import i18n from 'i18n';

import { getVendorMappings } from '../store/selectors/ui.selector';
import { FormField, IField, IOption } from '../modules/core/types';
import { COMMON_VENDOR_FILTER_OPTIONS, PREFERENCES_FIELD_NAMES } from '../modules/core/shared';
import { Dropdown } from '../modules/core/components';

interface IUseVendorFieldAndOptionsParams {
  isDisabled?: boolean;
  optionsToExclude?: string[];
}

interface IUseVendorFieldAndOptions {
  VENDOR_FIELD: IField;
  VENDOR_FILTER_OPTIONS: IOption[];
}

export const useVendorFieldAndOptions = (params: IUseVendorFieldAndOptionsParams = {}): IUseVendorFieldAndOptions => {
  const { isDisabled, optionsToExclude } = params;
  const vendorOptions = useSelector(getVendorMappings);
  const TRANSFORMED_VENDOR_OPTIONS: string[][] = [];

  Object.values(vendorOptions).forEach((vendor) => {
    Object.entries(vendor).forEach((subVendor) => TRANSFORMED_VENDOR_OPTIONS.push(subVendor));
  });

  let VENDOR_FILTER_OPTIONS: IOption[] = [
    ...TRANSFORMED_VENDOR_OPTIONS.map((vendor) => ({
      value: vendor[0],
      title: vendor[1],
    })),
    ...COMMON_VENDOR_FILTER_OPTIONS,
  ];

  if (optionsToExclude && optionsToExclude.length > 0) {
    VENDOR_FILTER_OPTIONS = VENDOR_FILTER_OPTIONS.filter((option) => !optionsToExclude?.includes(String(option.value)));
  }

  const VENDOR_FIELD: IField = {
    name: PREFERENCES_FIELD_NAMES.VENDOR_FIELD,
    component: Dropdown as FormField,
    controlProps: {
      options: VENDOR_FILTER_OPTIONS,
      disabled: isDisabled,
    },
    label: i18n.t('components.preferences.labels.guidebook'),
    isVerticalAlign: true,
  };

  return { VENDOR_FIELD, VENDOR_FILTER_OPTIONS };
};
